<template>
	<c-modal @close="close" :title="'Oproep afronden'">

		<c-form ref="form" @valid="submit" class="margin-t-40" >

			<div class="c-form-element c-form-element--horizontal no-margin-b">
				<div class="c-form-element__label no-margin-t">
					<label>{{delivery.client.contacts[0] ? 'Voornaam' : 'Naam' }}</label>
				</div>
				
				<div class="c-form-element__container c-form-element__container--text" v-if="delivery.delivery_type_id == $constants.delivery.BULK_LEVERING">
					{{ delivery.contact }}				
				</div>
				<div class="c-form-element__container c-form-element__container--text" v-else>
					{{ delivery.client.contacts[0] ?  delivery.client.contacts[0].first_name + delivery.client.contacts[0].last_name : delivery.client.name }}				
				</div>
			</div>

			<div class="c-form-element c-form-element--horizontal no-margin-b" v-if="delivery.client.contacts[0]">
				<div class="c-form-element__label no-margin-t">
					<label>Functie</label>
				</div>
				<div class="c-form-element__container c-form-element__container--text">
					{{delivery.client.contacts[0].title}}
				</div>
			</div>

			<div class="c-form-element c-form-element--horizontal" v-if="delivery.client.contacts[0]">
				<div class="c-form-element__label no-margin-t">
					<label>Telefoonnr.</label>
				</div>
				<div class="c-form-element__container c-form-element__container--text">
					{{delivery.client.contacts[0].phone}}
				</div>
			</div>

			<div v-if="delivery.delivery_type_id !== $constants.delivery.BULK_LEVERING">
				<c-checkbox v-if="items.length > 0"
					id="stock"
					v-model="stock"
					:horizontal="true"
					:label="'Bezorgen'"
					:labeltext="'name'"
					:options="items"
					:ValueName="'pickup.item_id,id,pickup.is_pickup'">
				</c-checkbox>

				<c-checkbox v-if="pickupItems.length > 0"
					id="stock"
					v-model="stock"
					:horizontal="true"
					:label="'Ophalen'"
					:labeltext="'name'"
					:options="pickupItems"
					:ValueName="'pickup.item_id,id,pickup.is_pickup'">
				</c-checkbox>

				<c-signature
					:horizontal="true"
					:label="'Digitale handtekening'"
					ref="signature_delivery"
					name="handtekening"/>

			</div>


			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Aftekenen</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>

</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CSignature from '@components/form/input/Signature';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal, CSignature
	},
	data() {
		return {
			stock: [],
			items: [],
			pickupItems: [],
			backorder_items: [],
			comment: ''
		};
	},
	props: {
		delivery: {
			required: true,
		}
	},
	methods: {
		products(delivery){
			this.items = [];
			this.pickupItems = [];
			delivery.products.forEach(( component) => {

				if(component.pickup.is_pickup == 0)
				{
					this.items.push(component);
				}
				else{
					this.pickupItems.push(component);
				}
			});
		},
		checkProducts(){

			let countPickup = 0;
			let countDeliver = 0;

			let pickup = "Nog op te halen artikelen: ";
			let deliver = "Niet geleverde artikelen: ";
			
			for(const product of this.delivery.products) {
				if(!this.stock.includes(product.pickup.item_id + " " + product.pickup.product_id + " " + product.pickup.is_pickup)){
					this.backorder_items.push(product);

					if(product.pickup.is_pickup == 0){
						deliver = deliver + " " + product.name + ",";
						countDeliver++
					}
					else{
						pickup = pickup + " " + product.name + ",";
						countPickup++
					}
				}
			}
			
			if(countDeliver == 0 && countPickup == 0){
				this.comment = null;
			}
			else if(countDeliver ==! 0 && countPickup == 0){
				this.comment = deliver;
			}
			else if(countDeliver == 0 && countPickup ==! 0){
				this.comment = pickup;
			}
			else{
				this.comment = pickup + deliver;
			}

		},
		submit() {

			let ItemsData = {
				items: []
			};

			if(this.delivery.delivery_type_id == this.$constants.delivery.BULK_LEVERING)
			{
				const items = this.delivery.items;
				items.forEach( (component, index) => {
					ItemsData['items'][index] = {item_id: component.id, is_pickup: 0};
				});
			}
			else {
				this.stock.forEach( (component, index) => {
					let item = '';
					item = component.split(' ');
					ItemsData['items'][index] = {item_id: item[0], product_id: item[1], is_pickup: item[2]};
				});
			}

			let id = this.delivery.id;
			let data = '';

			if(this.delivery.delivery_type_id == this.$constants.delivery.BULK_LEVERING)
			{
				data = Object.assign(ItemsData, {id: id}, {delivery_type_id: this.delivery.delivery_type_id }, {client_id: this.delivery.client_id}, {comment: this.comment}, {backorder_items: this.backorder_items});
			}
			else{
				this.checkProducts();
				let handtekening = this.$refs.signature_delivery.signature();
				
				data = Object.assign({handtekening: handtekening}, ItemsData, {id: id}, {delivery_type_id: this.delivery.delivery_type_id }, {client_id: this.delivery.client_id}, {comment: this.comment}, {backorder_items: this.backorder_items});
			}

			this.$xhr.post('/api/finish/delivery',  data).then( ( {result}) => {
				this.close();
				this.$emit('added');
				this.$store.dispatch('toast/success', {title: 'Levering afronden', text: 'De levering is afgerond'});
			}).catch( (e) => {
				if (e instanceof ValidationError) {
					this.$refs.form.setErrors(e.errors);
				}
				this.$store.dispatch('toast/alert', {title: 'Levering afronden', text: 'Er is helaas iets fout gegaan bij het afronden van de levering'});
			});

		},
		close() {
			this.$emit('close');
		},
	},
	mounted(){
		this.products(this.delivery);
	}
}
</script>
